import React from "react";
import { urlFor } from "../lib/client";

const Product = ({ product: { image, name, price } }) => {
  return (
    <div>
      <div className="product-card">
        <a href="https://discord.com/channels/784794493580476436/1022406330834755594">
          <img src={urlFor(image && image[0])} width={300} height={300} className="product-image" />
        </a>
        <p className="product-name">{name}</p>
        <p className="product-price">Rs.{price}</p>
      </div>
    </div>
  );
};

export default Product;
